import client from "api/client";
import type { DailyApi, FloatApi, MNTRApi, MonthlyApi, RevenueApi, TotalAccountsApi } from "api/models/reporting";


const base = "/admin/reporting";

const reporting = {
	dau: (payload: { timeZone: string }) => client.post<DailyApi>(base + "/dau", payload),
	rmau: (payload: { timeZone: string }) => client.post<MonthlyApi>(base + "/rmau", payload),
	ta: (payload: { timeZone: string }) => client.post<TotalAccountsApi>(base + "/ta", payload),
	revenue: (payload: { timeZone: string }) => client.post<RevenueApi>(base + "/revenue", payload),
	float: (payload: { timeZone: string }) => client.post<FloatApi>(base + "/float", payload),
	monetizedTraffic: (payload: { timeZone: string }) => client.post<MNTRApi>(base + "/mntr", payload)
};

export default reporting;